// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_YMk","cls2":"JournalSubscriptionPage-cls2_6-N JournalSubscriptionPage-cls1_YMk"};